import React from "react";
import moment from 'moment';
import axios from 'axios';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Carousel,Upload, Modal,Image   } from 'antd';
import ModalImage from "react-modal-image";
import $ from 'jquery';


import blank_slider from '../../assets/images/icon/blank_slider.jpg';
import edit from '../../assets/images/icon/edit.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function onChange(a, b, c) {
  console.log(a, b, c);
}

function callback(key) {
  console.log(key);
}


function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			fileList: [],
			name: '',
			email: '',
			primary_mobile: '',
			secondry_mobile: '',
			city: '',
			locality: '',
			address: '',
			zipcode: '',
			working_days: '',
			timings: '',
			programs: '',
			trust_name: '',
			twitter: '',
			facebook: '',
			website: '',
			youtube: '',
			instagram: '',
			logo:'',
			file1:null,
			school_img: '',
		}
		this.goBack = this.goBack.bind(this);	
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {user_id : user_id,school_id:school_id}
			getData('erp/school_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							name: result['data']['0']['name'],
							email: result['data']['0']['email'],
							primary_mobile: result['data']['0']['primary_mobile'],
							secondry_mobile: result['data']['0']['secondry_mobile'],
							city: result['data']['0']['city'],
							locality: result['data']['0']['locality'],
							address: result['data']['0']['address'],
							zipcode: result['data']['0']['zipcode'],
							working_days: result['data']['0']['working_days'],
							timings: result['data']['0']['timings'],
							programs: result['data']['0']['programs'],
							trust_name: result['data']['0']['trust_name'],
							twitter: result['data']['0']['twitter'],
							facebook: result['data']['0']['facebook'],
							website: result['data']['0']['website'],
							youtube: result['data']['0']['youtube'],
							instagram: result['data']['0']['instagram'],
							logo: result['data']['0']['logo'],
						});
						
					}else{
						this.setState({
							school_list: [],
						});
					}
				}
			});
			getData('franchise/country_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							country_list: result['data'],
						});
					}else{
						this.setState({
							country_list: [],
						});
					}
				}
			});
			
			getData('franchise/school_type',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_type: result['data'],
						});
					}else{
						this.setState({
							school_type: [],
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
 
    file_preview1 = (e) => {
		let file = e.target.files[0];
		if(file.size<=505000){	
		$('#file_preview1').html('1 file selected');
		this.setState({ file1: e.target.files[0]});
		}
		else{
		 message.config({ top: 150});
		 message.error('Error! Max file size 500KB allowed!');	
	}
   }


	handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

		this.setState({
		  previewImage: file.url || file.preview,
		  previewVisible: true,
		  previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
		});
	};


  
  handleChange = (fileList) => {
	  console.log('fileList',fileList);
    //this.setState({ fileList });
  }
  
  
  
  
  goBack(){
		window.location.href = '/school-profile/index';
	}
	
	handleSubmit=(e)=>{
    if(localStorage.getItem('schoolData')){
	e.preventDefault();
    this.setState({ loading: true });
    var storedArray = JSON.parse(localStorage.getItem("schoolData"));
	this.setState({ user_id : storedArray['data'][0]['user_id'] });
	var user_id = storedArray['data'][0]['user_id'];
	var school_id = storedArray['data'][0]['school_id'];
		
		if(this.state.name == ''){
			message.config({ top: 150});
			message.error('Please Insert School Name',2);
			this.setState({ loading: false });
		}else if(this.state.locality == ''){
			message.config({ top: 150});
			message.error('Please Insert School Locality',2);
			this.setState({ loading: false });
		}else if(this.state.address == ''){
			message.config({ top: 150});
			message.error('Please Insert School Address',2);
			this.setState({ loading: false });
		}else if(this.state.city == ''){
			message.config({ top: 150});
			message.error('Please Insert School City',2);
			this.setState({ loading: false });
		}
		else{
		var app = {
			school_id: school_id ,
			user_id: user_id ,
			name: this.state.name ,
			email: this.state.email ,
			primary_mobile: this.state.primary_mobile ,
			secondry_mobile: this.state.secondry_mobile ,
			city: this.state.city ,
			locality: this.state.locality ,
			address: this.state.address ,
			working_days: this.state.working_days ,
			timings: this.state.timings ,
			programs: this.state.programs ,
			trust_name: this.state.trust_name ,
			twitter: this.state.twitter ,
			facebook: this.state.facebook ,
			website: this.state.website ,
			youtube: this.state.youtube ,
			instagram: this.state.instagram ,
		}
		
      getData('erp/edit_school',app).then((result) => {
      if(result.status==400){
            message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
		  
		  		  
			  //upload images start
			  const selectedFiles = this.state.file_list; 	
			  const data = new FormData() 			
				data.append('file1', this.state.file1)
				data.append('pid', result.pid)	     
				data.append('user_id', this.state.user_id)
				let baseurl = "https://kcisapi.kidzonia.co.in/v1/erp/upload_school_images";	
				
				axios.post(baseurl, data, {
				})
				.then(res => {
				    this.setState({ loading: true });
					message.config({ top: 150});
					message.success('School Updated',2);
					this.setState({ loading: false });
					this.setState({comment_text:''});
					window.location.href = '/school-profile/index';	
				})
				//upload images ends		 

          }
      });
			
		}
		
		
	}else{
		message.config({ top: 150});
		message.error('Please Login First',2);
		this.setState({ loading: false });
	}
  }
  
	render()

	{
	
	const { size } = this.state;
	
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     const uploadButton = (
      <div>
        <div className="ant-upload-text">Upload</div>
      </div>
    );				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 	 		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Edit School Profile</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/school-profile/index">School Profile</a>
                           </li>
                           <li class="breadcrumb-item active">Edit School Profile
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		
          
			<div class="col s12 m12 ex-padd">
            <div class="container view-Profile viewprograms view-Profile-mobile">
			   <div class="col s12 m12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 iq-card2 bg-color-1">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header={this.state.name} classname="as" key="1">
						<div class="bb d-flow pb-20">
						<div class="col m12 s12 mb-20">
						<Carousel class="mb-20" afterChange={onChange}>
							<div>
							  <img src={blank_slider} />
							</div>
							<div>
							 <img src={blank_slider} />
							</div>
							
						  </Carousel>
						
						</div>
						<div class="col m12 s12 no-padd">
							<div class="col m4 s12">
								<label>School Name</label>
								<input type="text" name="name" defaultValue={this.state.name} onChange={this.handleSizeChange} />
							</div>
							<div class="col m4 s12">
								<label>Locality</label>
								<input type="text" name="locality"  defaultValue={this.state.locality} onChange={this.handleSizeChange} />
							</div>
							<div class="col m4 s12">
								<label>City</label>
								<input type="text" name="city" defaultValue={this.state.city} onChange={this.handleSizeChange} />
							</div>
							<div class="col m4 s12">
								<label>Email</label>
								<input type="text" name="email"  defaultValue={this.state.email} onChange={this.handleSizeChange} />
							</div>
							<div class="col m4 s12">
								<label>Primary Mobile</label>
								<input type="text"  name="primary_mobile" defaultValue={this.state.primary_mobile} onChange={this.handleSizeChange} />
							</div>
							<div class="col m4 s12">
								<label>Secondary Mobile</label>
								<input type="text" name="secondry_mobile" defaultValue={this.state.secondry_mobile} onChange={this.handleSizeChange} />
							</div>
							<div class="col m12 s12">
								<label>Address</label>
								<input type="text" name="address" defaultValue={this.state.address} onChange={this.handleSizeChange} />
							</div>
							<div class="col m12 s12">
								<label>Working Days</label>
								<input type="text" name="working_days" defaultValue={this.state.working_days} onChange={this.handleSizeChange} />
							</div>
							<div class="col m12 s12">
								<label>Timings</label>
								<input type="text" name="timings" defaultValue={this.state.timings}  onChange={this.handleSizeChange}/>
							</div>
							<div class="col m12 s12">
								<label>Program</label>
								<input type="text" name="programs" defaultValue={this.state.programs}   onChange={this.handleSizeChange}/>
							</div>
							<div class="col m12 s12">
								<label>Trust Name</label>
								<input type="text" name="trust_name" defaultValue={this.state.trust_name}  onChange={this.handleSizeChange}/>
							</div>
							<div class="col m6 s12 photos hidden">
								<label >Add Photo</label>
						
								<div className="clearfix mt-10">
									<Upload
									  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
									  listType="picture-card"
									  fileList={fileList}
									  onPreview={this.handlePreview}
									  onChange={this.handleChange}
									>
									  {fileList.length >= 1 ? null : uploadButton}
									</Upload>
									<Modal
									  visible={previewVisible}
									  title={previewTitle}
									  footer={null}
									  onCancel={this.handleCancel}
									>
									  <img alt="example" style={{ width: '100%' }} src={previewImage} />
									</Modal>
								  </div>
                                 
						
						
							</div>
							<div class="col m6 s12 photos">
								<label class="">Add Logo <br/><small>(Accepts - .png, .jpg, .jpeg)</small></label>
								 <div className="clearfix mt-10">
									 <div> 
									<label class="ant-btn snd-btn upload-btn mupload-btn" for="file1" id="file_preview1"><i class="feather icon-upload"></i> Choose File</label>
									<input id="file1" type="file" accept=".png, .jpg, .jpeg," onChange={this.file_preview1.bind(this)} style={{display: 'none',opacity: '0'}}/> 
                                    </div>	

										{(() => {
											if (this.state.logo != '') {
											return (											
											<p className="mt-2" style={{width:"100px"}}><ModalImage  small={this.state.logo} large={this.state.logo} hideDownload="true" /></p>	
											 )
											 }
										})()}
									
								  </div>
							</div>
						</div>
						
						 
						</div>  
						
						
						</Panel>
					  </Collapse>
					  </div>
					  <div class="children mb-20 iq-card2 bg-color-6">
					  <Collapse defaultActiveKey={['2']} onChange={callback}>
						<Panel header="Follow Us" key="2">
						<div class="bb d-flow pb-20">
						<div class="col m12 s12 no-padd">
							<div class="col m4 s12">
								<label>Twitter Handle</label>
								<input type="text" name="twitter" defaultValue={this.state.twitter}  onChange={this.handleSizeChange}/>
							</div>
							<div class="col m4 s12">
								<label>Facebook Page</label>
								<input type="text" name="facebook" defaultValue={this.state.facebook} onChange={this.handleSizeChange} />
							</div>
							<div class="col m4 s12">
								<label>Website</label>
								<input type="text" name="website" defaultValue={this.state.website} onChange={this.handleSizeChange}/>
							</div>
							<div class="col m4 s12">
								<label>Youtube Page</label>
								<input type="text" name="youtube" defaultValue={this.state.youtube} onChange={this.handleSizeChange} />
							</div>
							<div class="col m4 s12">
								<label>Instagram Page</label>
								<input type="text" name="instagram" defaultValue={this.state.instagram} onChange={this.handleSizeChange}/>
							</div>
							
						</div>
						
						 
						</div>  
						
						
						</Panel>
					  </Collapse>
					</div> 
					 
					
									
					
					<div class="col m12 s12 meal mt-20 mb-20 pt-20 bt center">
						  <Button className="cancel-btn large-btn"  onClick={this.goBack}>Back</Button>
						 <Button className="snd-btn large-btn" onClick={this.handleSubmit} loading={this.state.loading} >Save</Button>
					</div>
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
